/**
 * Analytics Service - Service for analytics and reporting operations
 */
/**
 * Analytics Service class
 * Platform-agnostic service for analytics operations
 */
export class AnalyticsService {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    /**
     * Get cycle time trend data for a department
     * @param departmentId - Department ID
     * @param startDate - Start date (ISO 8601 format)
     * @param endDate - End date (ISO 8601 format)
     * @param granularity - Data granularity (daily, weekly, monthly)
     */
    async getCycleTimeTrend(departmentId, startDate, endDate, granularity = 'daily') {
        try {
            const response = await this.apiClient.get(`/analytics/cycle-time/departments/${departmentId}/trend`, {
                start_date: startDate,
                end_date: endDate,
                granularity,
            });
            return response.data || response;
        }
        catch (error) {
            console.error('Failed to fetch cycle time trend:', error);
            throw error;
        }
    }
    /**
     * Get work orders contributing to cycle time for a department
     * @param params - Request parameters
     */
    async getCycleTimeWorkOrders(params) {
        try {
            const response = await this.apiClient.get(`/analytics/cycle-time/departments/${params.departmentId}/work-orders`, {
                start_date: params.startDate,
                end_date: params.endDate,
                limit: params.limit,
                offset: params.offset,
                include_active: params.includeActive,
            });
            return response.data || response;
        }
        catch (error) {
            console.error('Failed to fetch cycle time work orders:', error);
            throw error;
        }
    }
}
/**
 * Singleton instance for web platform
 * This will be initialized in the web app's auth.ts
 */
let analyticsServiceInstance = null;
export const initializeAnalyticsService = (apiClient) => {
    analyticsServiceInstance = new AnalyticsService(apiClient);
};
export const getAnalyticsService = () => {
    if (!analyticsServiceInstance) {
        throw new Error('Analytics service not initialized. Call initializeAnalyticsService first.');
    }
    return analyticsServiceInstance;
};
